import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import SVButton from 'components/elements/SVButton';

interface DeleteModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  show,
  onHide,
  onConfirm,
}) => {
  const [confirmValue, setConfirmValue] = useState('');
  const confirmText = 'delete';

  const handleConfirm = () => {
    if (confirmValue.toLowerCase() === confirmText) {
      onConfirm();
      setConfirmValue('');
    }
  };

  const handleClose = () => {
    setConfirmValue('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Are you sure you want to delete this Verification Process?
          <br />
          This cannot be undone.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group
          controlId="deleteConfirm"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmValue(e.target.value)}
        >
          <Form.Label>
            {`To confirm, please type "${confirmText}" in the field below.`}
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="type delete here"
            value={confirmValue}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <SVButton variant="cancel" onClick={handleClose}>
          No
        </SVButton>
        <SVButton
          variant="danger"
          onClick={handleConfirm}
          disabled={confirmValue !== confirmText}
        >
          Yes
        </SVButton>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
